import { render, staticRenderFns } from "./CaptchaView.vue?vue&type=template&id=18719bd2&scoped=true"
import script from "./CaptchaView.vue?vue&type=script&lang=js"
export * from "./CaptchaView.vue?vue&type=script&lang=js"
import style0 from "./CaptchaView.vue?vue&type=style&index=0&id=18719bd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18719bd2",
  null
  
)

export default component.exports